import { useClientStore } from "@/store/client";
import { usePanierStore } from "@/store/panier";

const waitForMiam = () => {
  return new Promise((resolve, reject) => {
    let nbIterations = 0;
    let interval = setInterval(() => {
      if (window.miam) {
        resolve();
      }
      if (window.miam || nbIterations >= 10) {
        clearInterval(interval);
        interval = null;
        if (!window.miam) {
          reject(new Error("Script miam introuvable"));
        }
      }
      nbIterations++;
    }, 200);
  });
}

export default defineNuxtPlugin(({ $pinia }) => {
  const config = useRuntimeConfig();

  const panierStore = usePanierStore($pinia);
  const clientStore = useClientStore($pinia);

  if (!config.public.MIAM_SHOW_RECETTES || clientStore.isPro) {
    return;
  }
  // volontairement pas async pour que le plugin ne soit pas bloquant
  waitForMiam().then(() => {
    window.miam.basket.stats$.subscribe((stats) => {
      panierStore.setRecipesCount(parseInt(stats.recipesCount, 10));
    });
  }).catch(() => { });
});
